import styled from 'styled-components';
import { Flex, Image, mediaBreakpointMixin } from '@zillow/constellation';
import BlueBackgroundImage from 'images/zrmLogin/blueBackground.png';

export const FlexContainer = styled(Flex)`
    height: 800px;
`;

export const StyledImage = styled(Image)`
    height: 100%;
`;

export const Banner = styled(Image)`
    max-width: 350px;
    margin-left: 10%;
    margin-top: calc(48px + 10%);
`;

export const BottomAlignedImage = styled(Image)`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 200px;
`;

export const DesktopImagesContainer = styled.div`
    position: relative;
    background-image: url(${BlueBackgroundImage});
    background-size: 100% 100%;
    width: 50%;
    overflow: hidden;

    @media ${mediaBreakpointMixin('lg_lte')} {
        display: none;
    }
`;

export const MobileWebImage = styled(Image)`
    @media ${mediaBreakpointMixin('md')} {
        display: none;
    }
`;

export const RegLoginContainer = styled.div`
    margin: 0 auto;
    padding-bottom: 300px;
`;
